module.exports = __webpack_public_path__ + "img/logo.c99f843b.svg";